module.exports = __webpack_public_path__ + "static/media/customerservice.4b7d00ee.png";